/**
 * Prosmotr kiritish maydoni (`VideoChecksSection.tsx`) uchun sof yordamchi funksiya —
 * komponentdan ataylab ajratilgan, chunki bu aynan qo'lda ko'p marta (kuniga o'nlab)
 * ishlatiladigan, xato narxi yuqori (pul hisobiga kiradi) kirish nuqtasi.
 */

/**
 * Kiritilgan matnni prosmotr soniga aylantiradi.
 *
 * Admin bu raqamni ko'pincha o'zi terib yozmaydi — blogerning skrinshotidan yoki Instagram
 * ilovasining o'zidan ko'chirib (copy-paste) oladi. Ikkalasi ham sonni ming ajratkichi bilan
 * ko'rsatadi: "12 400" (oddiy bo'shliq bilan), "12,400" (AQSH uslubi), "12.400" (ba'zi lokal
 * formatlar). Shuning uchun bo'shliq/vergul/nuqta/pastki chiziq — HAMMASI ming ajratkichi deb
 * hisoblanib olib tashlanadi, faqat raqamlar qoladi. Oddiy JavaScript `\s` sinfi uzilmas
 * bo'shliqni (NBSP) ham qamrab oladi, shuning uchun `formatNumber()` chiqargan "12 400"ni shu
 * ekrandan qaytadan nusxalab qo'ysa ham to'g'ri o'qiladi.
 *
 * Manfiy son ATAYLAB rad etiladi ("-" bo'lsa `null`) — belgini shunchaki kesib tashlash uni
 * musbatga aylantirib, xato ma'lumotni jimgina "to'g'irlab" yuborardi. Bo'sh, harfli yoki
 * ishoradan boshlangan kirishda ham `null` qaytadi — chaqiruvchi buni "hali yaroqli qiymat
 * yo'q" deb talqin qiladi (submit tugmasi o'chirilgan qoladi).
 */
export function parseViewsInput(raw: string): number | null {
  const trimmed = raw.trim()
  if (trimmed.length === 0) return null
  if (trimmed.startsWith('-') || trimmed.startsWith('+')) return null

  const cleaned = trimmed.replace(/[\s,.'_]/g, '')
  if (!/^\d+$/.test(cleaned)) return null

  const value = Number(cleaned)
  if (!Number.isSafeInteger(value)) return null
  return value
}
